<template>
  <div class="services">
    <div class="container">
      <div class="page-title text-center py-5">
        <h1>Our <span>Services</span></h1>
      </div>
    </div>

    <div class="container">
      <div v-for="service in services" :key="service.id">
        <div class="row py-5">
          <div
              class="col-md-5 d-flex flex-row align-items-center justify-content-center"
              :class="service.id % 2 ? 'order-md-1 justify-content-md-end' : 'order-md-3'"
          >
            <div class="row">
              <div
                  class="col-md-5 d-none d-md-block service-item service-item__id"
                  :class="service.id % 2 ? 'order-1' : 'order-2'"
              >
                <p>0{{ service.id }}</p>
              </div>
              <div
                  class="col-md-7 service-item service-item__icon"
                  :class="service.id % 2 ? 'order-md-2' : 'order-md-1'"
              >
                <div class="service-item service-item__icon--circle-3x">
                  <div class="service-item service-item__icon--circle-2x">
                    <div class="service-item service-item__icon--circle-1x">
                      <font-awesome-icon :icon="['fas', service.icon]" size="2x" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
              class="col-md-5 d-flex flex-column justify-content-center text-center text-md-left"
              :class="service.id % 2 ? 'order-md-3' : 'order-md-1'"
          >
            <div class="block service-item service-item__description">
              <h3>{{ service.name }}</h3>
              <p>{{ service.short_caption }}</p>
              <router-link :to="{ name: 'SingleService', params: { slug: service.slug, name: service.name, category: service.category, icon: service.icon, services } }">Learn more</router-link>
            </div>
          </div>
          <div v-if="service.id % 2 === 0" class="col-2 order-2 d-none d-md-block">
            <svg>
              <line
                  stroke-width="1px"
                  stroke="#000000"
                  x1="50%"
                  y1="50%"
                  x2="100%"
                  y2="50%"
                  style="stroke: #B3B1B1"
                  stroke-dasharray="4"
              />
              <line
                  v-show="isLastItem"
                  stroke-width="1px"
                  stroke="#000000"
                  x1="50%"
                  y1="50%"
                  x2="50%"
                  y2="200%"
                  style="stroke: #B3B1B1"
                  stroke-dasharray="4"
              />
              <circle x1="0" y1="0" cx="50%" cy="50%" r="10" fill="#B3B1B1" />
            </svg>
          </div>
          <div v-else class="col-2 order-2 d-none d-md-block">
            <svg>
              <line
                  stroke-width="1px"
                  stroke="#000000"
                  x1="50%"
                  y1="50%"
                  x2="0"
                  y2="50%"
                  style="stroke: #B3B1B1"
                  stroke-dasharray="4"
              />
              <line
                  stroke-width="1px"
                  stroke="#000000"
                  x1="50%"
                  y1="50%"
                  x2="50%"
                  y2="200%"
                  style="stroke: #B3B1B1"
                  stroke-dasharray="4"
              />
              <circle x1="0" y1="0" cx="50%" cy="50%" r="10" fill="#B3B1B1" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Services",
  data() {
    return {
      services: [
        {
          id: 1,
          name: "Web Development",
          icon: "code",
          short_caption:
              "Web Design & Development Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo.",
          category: 'Development',
          slug: "web-development"
        },
        {
          id: 2,
          name: "UX / UI Design",
          icon: "rocket",
          short_caption:
              "User Experience and User Interface design ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo.",
          category: 'Design',
          slug: "ux-ui-design"
        },
        {
          id: 3,
          name: "Email Marketing",
          icon: "envelope",
          short_caption:
              "SEO Optimization Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo.",
          category: 'Digital Marketing',
          slug: "email-marketing"
        },
        {
          id: 4,
          name: "Graphic Design",
          icon: "layer-group",
          short_caption:
              "Graphic Design Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent sit amet rutrum justo.",
          category: 'Design',
          slug: "graphic-design"
        }
      ],
      lastItem: false
    };
  },
  methods: {
    isLastItem: function(id) {
      if(id === this.services.length) {
        return true;
      } else {
        return false;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.page {
  &-title {
    h1 {
      &:before {
        content: "SERVICES";
      }
    }
  }
}

.service {
  &-item {
    &__id {
      p {
        color: $dark-grey;
        opacity: 10%;
        font-size: 96px;
        font-weight: 600;
      }
    }
    &__icon {
      font-size: 20px;
      svg {
        top: 50%;
        left: 50%;
        color: $light-blue;
        position: absolute;
        transform: translate3d(-50%, -50%, 0);
      }
      &--circle-1x {
        width: 100px;
        height: 100px;
        border: 5px solid $light-blue;
        background: $dark-blue;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
      }
      &--circle-2x {
        width: 120px;
        height: 120px;
        border: 1px solid $dark-blue;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
      }
      &--circle-3x {
        width: 150px;
        height: 150px;
        border: 1px solid $dark-grey;
        border-radius: 50%;
        position: relative;
      }
    }
    &__description {
      a {
        color: $dark-blue;
        font-weight: 700;
        transition: color 0.3s ease-in;
        text-decoration: none;
        &:hover {
          color: $light-blue;
        }
      }
    }
  }
}
svg {
  overflow: visible;
  width: 100%;
  height: 100%;
}
</style>
